import type { OrganizationSchema } from 'data-layer';

interface OrganizationSchemaScriptProps {
  schema: OrganizationSchema;
}

export function OrganizationSchemaScript({ schema }: OrganizationSchemaScriptProps) {
  return (
    <script
      id="organization-schema-jsonld"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
